import React, { useState, useRef } from 'react'
import PropTypes from 'prop-types'
import { useStateValue } from '@State'

export function BadgeName({ disable }) {
  const [state, dispatch] = useStateValue()
  const [editName, setEditName] = useState(false)
  const nameInput = useRef(null)

  const changeMode = () => {
    setEditName(!editName)
  }

  const handleChange = () => {
    dispatch({
      type: 'UPDATE_BADGE_INFO',
      badgeInfo: { name: nameInput.current.value },
    })
    changeMode()
  }

  if (editName === true) {
    return (
      <div className="text-center input_element" id="name">
        <input
          type="text"
          id="name_input"
          ref={nameInput}
          defaultValue={state.badgeInfo.name}
          onBlur={handleChange}
        />
      </div>
    )
  } else {
    return (
      <div
        className={disable ? 'text-center' : 'text-center input_element'}
        id="name"
      >
        {state.badgeInfo.name}
        <div
          className={disable ? '' : 'icon icon_pencil'}
          id="name_pencil"
          onClick={changeMode}
        />
      </div>
    )
  }
}

BadgeName.propTypes = {
  disable: PropTypes.bool,
}
